import {Box, Button, Tabs} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import React, {useEffect, useMemo, useState} from "react";
import DetailProcessing from "./DetailProcessing/DetailProcessing";
import {constantsErrorMessages} from "../../../Constants";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import VariablesTable from "../../../components/UI/table/customer-detales/processing/VariablesTable";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMyOrdersSectionPath,
    buildMySamplesSectionPath,
    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
    CUSTOMER_SAMPLES_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import ExportDetail from "./ExportDetail";
import SamplesControllerService from "../../../API/samples/Customers/SamplesController";
import DetailService from "../../../API/orders/cutting/detail/DetailService";
import DetailReserveService from "../../../API/organization/DetailReserveService";
import WarehouseFinishedDetailService
    from "../../../API/orders/cutting/warehousefinisheddetail/WarehouseFinishedDetailService";
import DetailControllerService from "../../../API/details/customer/DetailControllerService";
import VariableControllerService from "../../../API/details/customer/VariableControllerService";
import VariableControllerServiceOrganization
    from "../../../API/details/organization/VariableControllerServiceOrganization";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {VariablesFilterData} from "../../../data/FilterTables/VariablesFilterData";
import {refetchModelDetailCached} from "../../../utils/cutting/modelDetailCache";

const LOADING_BOX_SX = {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const Loading = React.memo(() => (
    <Box sx={LOADING_BOX_SX}>
        <CircularProgress disableShrink/>
    </Box>
))
const ComponentVariablesWithFilter = withFilter(VariablesTable, VariablesFilterData);
const Processing = ({organization, isReserve, isWarehouse, isDetailModel, composition}) => {
    const params = useParams();
    const detailId = params.id
    const {
        orderId = 0,
        customerOrderNumber,
        requestsCuttingId,
        requestsCuttingNumber,
        year,
        estimateId,
        modelId,
        estimateNumber,
        numberRequestsCutting,
        reserveId
    } = params
    const navigate = useNavigate();
    const pathname = useLocation().pathname

    const redirectOrders = () => {
        navigate('/customer/orders/');
    };
    const detailPathname = organization ? (estimateId ? `/organization/basic-models/${modelId}/estimates/${estimateId}/${estimateNumber}` : `/organization/requests-cutting/details/${requestsCuttingId}/${numberRequestsCutting}`) : `/customer/orders/${orderId}/${customerOrderNumber}/${year}`
    const redirectDetails = () => {
        !organization && EditLocalStoragePagesData(detailPathname, "tab", "6")
        navigate(detailPathname);
    };

    const [tab, setTab] = useState(1);

    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [change, setChange] = useState(true);

    const [alertData, setAlertData] = useState({}); //type 'error'| 'info' | 'success'| 'warning'
    const [detailData, setDetailData] = useState({});
    const [variables, setVariables] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const getDetailData = () => {
        if (isReserve) {
            DetailReserveService.get(detailId).then((response) => {
                setDetailData(response.data);
                setIsError(false);
            })
                .catch((error) => {
                    handleModalAlert(error)
                    navigate("/organization/detail-reserve")
                })
                .finally(() => setIsLoading(false))
        } else if (isWarehouse) {
            WarehouseFinishedDetailService.get(detailId).then((response) => {
                setDetailData(response.data);
                setIsError(false);
            })
                .catch((error) => {
                    handleModalAlert(error)
                    navigate("/organization/detail-warehouse")
                })
                .finally(() => setIsLoading(false))
        } else if (organization) {
            const loadDetail = isDetailModel
                ? () => refetchModelDetailCached(detailId)
                : () => DetailService.getById(detailId).then((response) => response.data);
            loadDetail().then((data) => {
                setDetailData(data);
                setIsError(false);
            })
                .catch((error) => {
                    handleModalAlert(error)
                    redirectDetails()
                })
                .finally(() => setIsLoading(false))
        } else if (orderId) {
            DetailControllerService.getById(orderId, detailId).then((response) => {
                setDetailData(response.data);
                setIsError(false);
            })
                .catch((error) => {
                    handleModalAlert(error)
                    redirectDetails()
                })
                .finally(() => setIsLoading(false))
        } else {
            SamplesControllerService.getById(detailId)
                .then(function (response) {
                    setDetailData(response.data.detailDto);
                    const vars = response.data.detailDto.variables
                    setVariables(Array.isArray(vars) ? vars : []);
                    setIsError(false)
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setIsLoading(false))
        }

    }
    const [loading, setLoading] = useState(false)
    const handleSubmitDetailModal = (data, setEditDetailModal, detailDataId, orderId) => {
        setLoading(true)
        const api = isReserve ? DetailReserveService.edit(detailDataId, {
            "name": data.name,
            "position": data.position,
            "length": data.length,
            "width": data.width,
            "l1": detailData.l1,
            "l1Name": detailData.l1Name,
            "l2": detailData.l2,
            "l2Name": detailData.l2Name,
            "w1": detailData.w1,
            "w1Name": detailData.w1Name,
            "w2": detailData.w2,
            "w2Name": detailData.w2Name,
            "groove": detailData.groove,
            "reserveLimit": detailData.reserveLimit,
            "materialOptionOrganizationId": detailData.materialOptionOrganizationId,
        }) : DetailControllerService.update(
            organization && requestsCuttingId ? (detailData.orderId ?? orderId) : orderId,
            detailDataId,
            data,
            {organization}
        )
        api.then(function (response) {
            setChange((change) => !change)
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .then(() => setEditDetailModal(false))
            .finally(() => setLoading(false))
    }

    const getVariablesData = () => {
        const api = organization ? VariableControllerServiceOrganization.get(detailId) : VariableControllerService.get(orderId, detailId)
        api.then(function (response) {
            const data = response?.data
            setVariables(Array.isArray(data) ? data : []);
            tableOptionsHandle((prev) => ({
                ...prev,
                totalElements: data.length
            }))
            setIsError(false)
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }

    const handleEditVariables = (data) => {
        setVariables(data)
        getDetailData()
    }

    useEffect(() => {
        setIsLoading(true)
        getDetailData()
        getVariablesData()
    }, [change]);

    return (
        isLoading
            ? <Loading/>
            : (
                <Box sx={{padding: "0 30px"}}>
                    <BreadcrumbsComponent
                        page={`Обработка детали ${detailData.position}`}
                        path={(isDetailModel || composition) ? [{name: "Главная", href: "/"}, {
                            name: "Настройки",
                            href: "/settings"
                        }] : isReserve ? [{name: "Главная", href: "/"}, {
                            name: "Резервы деталей",
                            href: "/organization/detail-reserve"
                        }] : isWarehouse ? [{name: "Главная", href: "/"}, {
                            name: "Складские детали",
                            href: "/organization/detail-warehouse"
                        }] : organization ? [{name: "Главная", href: "/"}, {
                            name: estimateId ? `Детали в смете ${estimateNumber}` : ` Детали на раскрой заявки ${numberRequestsCutting}`,
                            href: detailPathname
                        }] : orderId ? buildMyOrdersSectionPath(
                            CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
                            {
                                name: `Заказ № ${customerOrderNumber}`,
                                href: detailPathname,
                            },
                            {
                                name: "Детали",
                                href: requestsCuttingId
                                    ? `/customer/orders/${orderId}/${customerOrderNumber}/${year}/requests-cutting/${requestsCuttingId}/${requestsCuttingNumber}/details`
                                    : detailPathname,
                            },
                        ) : buildMySamplesSectionPath(CUSTOMER_SAMPLES_SUBMENU_BREADCRUMB)}/>
                    <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                        <ButtonGroupTabBar activeTab={tab}>
                            <Button tabIndex={1}
                                    onClick={() => setTab(1)}
                            >
                                <CheckIcon/>
                                Обработка
                            </Button>
                            <Button tabIndex={2}
                                    onClick={() => setTab(2)}
                            >
                                <CheckIcon/>
                                Переменные
                            </Button>
                            {organization && <Button
                                exporttabIndex={3}
                                onClick={() => setTab(3)}
                            >
                                <CheckIcon/>
                                Экспорт
                            </Button>}
                        </ButtonGroupTabBar>
                        {tab === 1 ? <DetailProcessing
                            setIsLoading={setIsLoading}
                            setIsError={setIsError}
                            detailId={detailId}
                            handleModalAlert={handleModalAlert}
                            setChange={setChange}
                            orderId={orderId}
                            customerOrderNumber={customerOrderNumber}
                            year={year}
                            detailData={detailData}
                            redirect={{orders: redirectOrders, details: redirectDetails}}
                            variables={variables}
                            organization={organization}
                            handleSubmitDetailModal={handleSubmitDetailModal}
                            isWarehouse={isWarehouse}
                            loading={loading}
                            model = {isDetailModel}
                            composition={composition}
                        /> : tab === 2 ? <ComponentVariablesWithFilter
                                data={variables}
                                isError={isError}
                                setData={handleEditVariables}
                                enableEditing={!isWarehouse}
                                orderId={orderId}
                                detailId={detailId}
                                organization={organization}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}/> :
                            <ExportDetail
                                orderId={orderId}
                                detailId={detailId}
                                position={detailData.position}
                                handleModalAlert={handleModalAlert}
                                setIsError={setIsError}
                                organization={organization}/>}
                    </Box>
                    <ModalAlert
                        data={alertData}
                        onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    />
                </Box>
            )
    )
}
export default Processing